import { ReactComponent as GhostIconSVG } from '../assets/images/ghost-icon.svg';

const GhostMessage = ({ customMessage = 'Nothing here, yet!' }: { customMessage?: string }) => {
  return (<>
    <div className="grow flex flex-col items-center justify-center">
      <GhostIconSVG />
        <div className="mt-4 font-sora font-semibold text-lg leading-[140%] text-light-grey">
          {customMessage}
        </div>
    </div>
  </>);
};

export default GhostMessage;
